import { createContext } from 'react';

import type { PetitionStatsState } from '#src/app/pages/petitionDetails/shared/types';

export const PetitionStatsContext = createContext<PetitionStatsState | undefined>(undefined);

export const PetitionStatsStateProvider = PetitionStatsContext.Provider;
